import React from 'react';

import GlobeIcon from '@atlaskit/icon/core/globe';

import LightbulbIcon from '@atlaskit/icon/core/lightbulb';

import PeopleGroupIcon from '@atlaskit/icon/core/people-group';

import type { NewCoreIconProps } from '@atlaskit/icon/types';

export enum IconKey {
	GlobeIcon = 'GlobeIcon',
	LightbulbIcon = 'LightbulbIcon',
	PeopleGroupIcon = 'PeopleGroupIcon',
}

export const IconConfig: Record<IconKey, React.ComponentType<NewCoreIconProps>> = {
	[IconKey.GlobeIcon]: GlobeIcon,
	[IconKey.LightbulbIcon]: LightbulbIcon,
	[IconKey.PeopleGroupIcon]: PeopleGroupIcon,
};

function isIconKey(key: string): key is IconKey {
	return Object.values(IconKey).includes(key as IconKey);
}

export function getIcon(iconKey: string): React.ComponentType<NewCoreIconProps> {
	return isIconKey(iconKey) ? IconConfig[iconKey] : GlobeIcon;
}
